import React from 'react';
import {SvgIcon} from '@material-ui/core';

export default function Home(props) {
  return (
    <SvgIcon {...props}>
      <g opacity="0.3">
        <path
          d="M10.0001 19V14H14.0001V19C14.0001 19.55 14.4501 20 15.0001 20H18.0001C18.5501 20 19.0001 19.55 19.0001 19V12H20.7001C21.1601 12 21.3801 11.43 21.0301 11.13L12.6701 3.59997C12.2901 3.25997 11.7101 3.25997 11.3301 3.59997L2.9701 11.13C2.6301 11.43 2.8401 12 3.3001 12H5.0001V19C5.0001 19.55 5.4501 20 6.0001 20H9.0001C9.5501 20 10.0001 19.55 10.0001 19Z"
          fill="white"/>
      </g>
    </SvgIcon>
  );
}
